export default __webpack_public_path__ + "static/media/vpn-red.a6cb0909.svg";